import { render, staticRenderFns } from "./registration-embed.vue?vue&type=template&id=45b8f966"
import script from "./registration-embed.vue?vue&type=script&lang=js"
export * from "./registration-embed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports